<template>
  <Flex
    justify="between"
    align="start"
    v-test="'sale-service-package'"
  >
    <Flex
      align="start"
      :gap="0.5"
    >
      <div
        :class="$style.quantity"
        v-test="'sale-service-package-quantity'"
      >
        <BaseText>{{ quantity }}</BaseText>
      </div>
      <Flex
        direction="column"
        :gap="0.25"
      >
        <Flex
          wrap
          align="center"
          :gap="0.5"
        >
          <BaseText v-test="'sale-service-package-name'">{{ name }}</BaseText>
          <BaseText
            v-if="discountPercentage"
            color="secondary"
            v-test="'sale-service-package-discount'"
          >
            {{ `(${discountPercentage}% ${$t('global.discount')})` }}
          </BaseText>
        </Flex>
        <BaseText
          v-for="(serviceName, index) in serviceNames"
          :key="index"
          color="secondary"
          size="s"
          v-test="'sale-service-package-service'"
        >
          {{ serviceName }}
        </BaseText>
      </Flex>
    </Flex>
    <Flex :gap="0.5">
      <BaseText
        v-if="originalPrice !== price"
        lineThrough
        inline
        v-test="'sale-service-package-original-price'"
      >
        {{ filters.currency(originalPrice) }}
      </BaseText>
      <BaseText v-test="'sale-service-package-price'">
        {{ filters.currency(price) }}
      </BaseText>
    </Flex>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import filters from '@/filters';

defineProps<{
  name: string;
  serviceNames: string[];
  quantity: number;
  price: number;
  originalPrice: number;
  discountPercentage: number;
}>();
</script>

<style
  lang="scss"
  module
>
.quantity {
  min-width: 20px;
}
</style>
